import React from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'
import { Link as RouterLink } from 'react-router-dom'
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined'
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline'
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined'
import WorkOutlineIcon from '@material-ui/icons/WorkOutline'
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import { IconWeb } from '../v2Components/icons'
import { SvgIcon } from '@material-ui/core'

import { colors } from '../../Themes'

import './sidebar.css'

const ModalSidebar = ({ isOpen, setIsOpen }) => {
  const closeModal = () => {
    setIsOpen(false)
  }
  return (
    <ReactModal
      className='ModalSidebar'
      overlayClassName='ModalOverlay'
      isOpen={isOpen}
      onRequestClose={closeModal}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
    >
      <ModalContainer>
        <Category>
          <CategoryTitleContainer>
            <Link to='/' onClick={closeModal}>
              <StyledHomeIcon />
              <CategoryTitle>Campanhas</CategoryTitle>
            </Link>
          </CategoryTitleContainer>
        </Category>
        <Category>
          <Link to='/controle-operacao' onClick={closeModal}>
            <SvgIcon>
              <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M13 15V12H16V10L20 13.5L16 17V15H13ZM15 16V19H12V21L7.99996 17.5L12 14V16H15ZM9.99996 6C7.78996 6 5.99996 7.8 5.99996 10C5.99996 11.91 7.34996 13.54 9.20996 13.92L14 9.86C13.9644 8.82334 13.5272 7.84109 12.7808 7.12081C12.0344 6.40052 11.0372 5.99861 9.99996 6ZM9.99996 12C8.89996 12 7.99996 11.11 7.99996 10C7.99996 8.89 8.89996 8 9.99996 8C11.1 8 12 8.9 12 10C12 11.1 11.11 12 9.99996 12ZM19.66 6.73L17.66 3.27C17.54 3.05 17.28 2.96 17.05 3.05L14.56 4.05C14.05 3.64 13.5 3.31 12.87 3.05L12.5 0.420002C12.4797 0.302219 12.4183 0.195429 12.3268 0.118553C12.2353 0.0416778 12.1195 -0.000319774 12 1.83347e-06H7.99996C7.74996 1.83347e-06 7.53996 0.180002 7.49996 0.420002L7.12996 3.07C6.49996 3.33 5.95996 3.66 5.43996 4.07L2.99996 3.05C2.76996 2.96 2.49996 3.05 2.38996 3.27L0.389964 6.73C0.259964 6.94 0.309964 7.22 0.499964 7.37L2.56996 9L2.49996 10L2.56996 11L0.459964 12.63C0.259964 12.78 0.209964 13.06 0.339964 13.27L2.33996 16.73C2.44996 17 2.73996 17.11 2.99996 17L5.49996 16C5.73996 16.19 5.99996 16.37 6.25996 16.53L7.90996 15.13C7.13996 14.8 6.45996 14.31 5.90996 13.68L3.49996 14.68L2.72996 13.38L4.79996 11.8C4.39996 10.6333 4.39996 9.36667 4.79996 8.2L2.68996 6.65L3.43996 5.35L5.84996 6.35C6.62996 5.45 7.67996 4.82 8.84996 4.57L9.24996 2H10.75L11.12 4.62C12.29 4.86 13.34 5.5 14.12 6.39L16.53 5.39L17.28 6.69L15.2 8.2C15.29 8.46 15.36 8.73 15.4 9H17.4L19.5 7.37C19.6034 7.30398 19.6776 7.20087 19.7073 7.08184C19.7371 6.96282 19.7201 6.83692 19.66 6.73ZM9.99996 6C7.78996 6 5.99996 7.8 5.99996 10C5.99996 11.91 7.34996 13.54 9.20996 13.92L14 9.86C13.9644 8.82334 13.5272 7.84109 12.7808 7.12081C12.0344 6.40052 11.0372 5.99861 9.99996 6ZM9.99996 12C8.89996 12 7.99996 11.11 7.99996 10C7.99996 8.89 8.89996 8 9.99996 8C11.1 8 12 8.9 12 10C12 11.1 11.11 12 9.99996 12ZM9.99996 6C7.78996 6 5.99996 7.8 5.99996 10C5.99996 11.91 7.34996 13.54 9.20996 13.92L14 9.86C13.9644 8.82334 13.5272 7.84109 12.7808 7.12081C12.0344 6.40052 11.0372 5.99861 9.99996 6ZM9.99996 12C8.89996 12 7.99996 11.11 7.99996 10C7.99996 8.89 8.89996 8 9.99996 8C11.1 8 12 8.9 12 10C12 11.1 11.11 12 9.99996 12Z'
                  fill='white'
                />
              </svg>
            </SvgIcon>
            <CategoryTitle>Controle de Operações</CategoryTitle>
          </Link>
        </Category>
        <Category>
          <Link to='/usuarios?role=S' onClick={closeModal}>
            <StyledSubscribersIcon />
            <CategoryTitle>Assinantes</CategoryTitle>
          </Link>
        </Category>
        <Category>
          <Link to='/usuarios?role=I' onClick={closeModal}>
            <StyledPeopleIcon />
            <CategoryTitle>Investidores</CategoryTitle>
          </Link>
        </Category>
        <Category>
          <Link to='/parceiros' onClick={closeModal}>
            <StyledWorkIcon />
            <CategoryTitle>Parcerias</CategoryTitle>
          </Link>
        </Category>
        <Category>
          <Link to='/solicitacoes-de-credito' onClick={closeModal}>
            <StyledMonetizationOnOutlinedIcon />
            <CategoryTitle>Solicitações de Crédito</CategoryTitle>
          </Link>
        </Category>
        <Category>
          <Link to='/funcionarios' onClick={closeModal}>
            <StyleAssignmentIndIcon />
            <CategoryTitle>Funcionários</CategoryTitle>
          </Link>
        </Category>
        <Category>
          <Link to='/home' onClick={closeModal}>
            <StyledHomeSiteIcon />
            <CategoryTitle>Conteúdo da Home</CategoryTitle>
          </Link>
        </Category>
      </ModalContainer>
    </ReactModal>
  )
}

const CategoryTitle = styled.span`
  white-space: nowrap;
  margin-left: 10px;
  font-size: 14px;
  font-weight: 500;
`

const ModalContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const StyledHomeSiteIcon = styled(IconWeb)`
  color: ${colors.white};
`

const StyledHomeIcon = styled(HomeOutlinedIcon)`
  color: ${colors.white};
`

const StyledPeopleIcon = styled(PeopleOutlineIcon)`
  color: ${colors.white};
`
const StyledSubscribersIcon = styled(CreateOutlinedIcon)`
  color: ${colors.white};
`

const StyledWorkIcon = styled(WorkOutlineIcon)`
  color: ${colors.white};
`

const StyleAssignmentIndIcon = styled(AssignmentIndIcon)`
  color: ${colors.white};
`

const StyledMonetizationOnOutlinedIcon = styled(MonetizationOnOutlinedIcon)`
  color: ${colors.white};
`

const Category = styled.div`
  width: 100%;
  padding: 15px;
  border-bottom: 1px solid ${colors.blue};
`

const CategoryTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Link = styled(RouterLink)`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: none;
  font-size: 18px;
  color: ${colors.white};
  display: flex;
  align-items: center;
  &:focus {
    outline: 0;
  }
`

export default ModalSidebar
